/* global globalThis */
import React, { useEffect, useState } from 'react';
import '../CoursesList/coursesList.scss';
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import {Typography, Box, LinearProgress} from '@material-ui/core';
import { ReactComponent as Live } from "../../../src/assets/images/live.svg";
import { recentCourseAction } from 'examsbook-react-sdk/actions';
import { useDispatch, useSelector } from 'react-redux';
import OverlayButton from '../../constants/OverlayButton';
import { ReactComponent as ExpiringClock } from "../../../src/assets/images/expiringclock.svg";
import { ReactComponent as PointsIcon } from "../../../src/assets/images/points.svg";
import { useTheme } from '../../constants/themeProvider';
import DefaultCourseImage from "../../../src/assets/images/course-image.jpg"
import { setCourseId, setCourseName, setCourseProgress, setTestData } from 'examsbook-react-sdk/actions/getCourses';
import { ReactComponent as CertifiedIcon } from "../../../src/assets/images/certifiedIcon.svg";
import moment from 'moment';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { ReactComponent as GreenTick } from "../../assets/images/greenTick.svg";

/**
 * My Courses card
 * @param props
 * @returns {*}
 * @constructor
 */
function MyCoursesCard(props) {
    const { testData, certificateListing, settingsData } = props;
    const history = useHistory();
    const dispatch = useDispatch();
    const t = useTranslations();
    const location = useLocation();
    const percentageCompletion = testData?.progressPercent ?? 0;
    const [certificateData, setCertificateData] = useState({})
    const showEvaluationTest = useSelector(state => state.filteredCourseList.showEvaluationTest) || location?.state?.showEvaluationTest;
    const showInstructions = useSelector(state => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;

    const [expireDays, setExpireDays] = useState('');
    const [courseExpired, setCourseExpired] = useState(false);
    const [courseCompletedOn, setCourseCompletedOn] = useState('');
    const [showComponent, setShowComponent] = useState(false);
    const theme = useTheme();
    const oldData = useSelector(state => state.filteredCourseList.testData);

    useEffect(() => {
        if (testData) {
            checkExpiration();
        }
    }, [testData]);

    useEffect(() => {
        getCertificateListing();
    },[testData, certificateListing])

    const checkExpiration = () => {
        const currentDate = new Date();

        let courseEndDate = null;
        if (testData?.endDate) {
            courseEndDate = new Date(testData.endDate);
        } else if (testData?.assignedCourseEndDate) {
            courseEndDate = new Date(testData.assignedCourseEndDate);
        }


        if (testData.completedOnDate && testData.completedOnDate > 0) {
            let courseCompletedOn = new Date(testData.completedOnDate)
            setCourseCompletedOn(courseCompletedOn)
        }
      // Set course expiry date if available
        if (courseEndDate) {
            const timeDifference = courseEndDate.getTime() - currentDate.getTime();
            setExpireDays(Math.ceil(timeDifference / (1000 * 60 * 60 * 24)));
        } else {
            // If no end date is available, set expiration days to null
            setExpireDays(null);
        }
    };

    useEffect(()=>{
        if (expireDays > 0) {
            setCourseExpired(false)
        } else{
            setCourseExpired(true)
        }
    },[expireDays])

    useEffect(() => {
        const timer = setTimeout(() => {
          setShowComponent(true);
        }, 200);
        return () => clearTimeout(timer);
    }, []);

    const callRecentApi = async () => {
        const payload = { courseId: testData?.courseId?._id };
        await dispatch(recentCourseAction(payload));
    };

    function handleGoToTestClick() {
        globalThis.dispatchEvent(new Event('storage'));
        reactGaEvent("Course Material", "Go To Course");
        callRecentApi()
        let recentCourseData = oldData ? JSON.parse(oldData) : [];
        const isDataExist = recentCourseData?.some((item) => item.courseId === testData?.courseId?._id);

        if (isDataExist !== true) {
            recentCourseData = [{ courseId: testData?.courseId?._id, subjectId: '', topicId: '', subjectDetail: testData, subjectName: '', topicName: '' }, ...recentCourseData]
        }
        if (recentCourseData.length === 4) {
            recentCourseData.pop(3);
        }
        const matchedCourse = recentCourseData.find(item => item.courseId === testData?.courseId?._id);
        dispatch(setCourseName(matchedCourse?.subjectDetail?.courseId?.name));
        dispatch(setCourseId(testData?.courseId?._id));
        dispatch(setCourseProgress(testData?.courseId?.progressPercent));
        dispatch(setTestData(JSON.stringify(recentCourseData)));
        history.push(`/course/${testData?.courseId?._id}`, { courseId: testData?.courseId?._id, subjectId: '', topicId: '', subjectDetail: testData, testData: JSON.stringify(recentCourseData), subjectName: '', topicName: '', courseName: matchedCourse?.subjectDetail?.courseId?.name, courseProgress: testData?.courseId?.progressPercent, showEvaluationTest: showEvaluationTest, showInstructions: showInstructions, isCourseExpired: courseExpired });
    }

    useEffect(() => {
        return () => {
            localStorage.removeItem('selectedTab');
        };
    }, [])

    const getCertificateListing = () => {
        const matchedCertificate = certificateListing?.find(item => item?.courseId?._id === testData?.courseId?._id);
        setCertificateData(matchedCertificate || {});
    }

    const courseImage = settingsData?.data?.[0]?.branding?.courseImage?.imagePath;
    const featuredImage = testData?.featured || courseImage || DefaultCourseImage;
    const hasCompletedOn = Boolean(courseCompletedOn);
    const badgeMaxWidth = certificateData?.courseId?._id === testData?.courseId?._id ? '15vw' : '30vw';
    let expiryLabel = t('Expired');
    if (expireDays > 0) {
        expiryLabel = hasCompletedOn
            ? `${t('Completed on')} ${moment(courseCompletedOn).format("DD-MMM-YYYY")}`
            : `${t('Expiring on')} ${moment(testData?.endDate).format("DD-MMM-YYYY")}`;
    }

    return (
      <Box className="card-list-image">
            <Box className='image-container image-fix'>
                <img style={{objectFit: 'contain', borderRadius: '4px 4px 0px 0px'}}
                     src={featuredImage}
                    alt="" onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = DefaultCourseImage;
                    }} />
            </Box>
        <Box className='card-list'>
            <Box className="course-module">
                {testData?.isSelfLearning === true ? <button className="course-learning" style={{border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor}}>{t('SELF LEARNING')}</button> : ''}
                {testData.isLive === true ? <button className="course-live-learning" style={{border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor}}><span className='live-image'><Live/></span><span>{t('live')}</span></button> : ''}
                <Box className="course-certificate-tag">
                    <Box>{certificateData?.courseId?._id === testData?.courseId?._id 
                        ? <Box className='certified-card-tag'>
                                <CertifiedIcon/>
                                <Box className='certified-text'>{t('Certified')}</Box>
                            </Box>
                        :
                        <Box style={{border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor}} className='certificate-card-tag'>
                            {t('CERTIFICATE')}
                        </Box>}
                    </Box>
                </Box>
            </Box>
           <p className='card-title'>{testData?.courseId?.name}</p>
            <Box className='card-description' dangerouslySetInnerHTML={{ __html: testData?.courseId?.description }}></Box>
            <Box className="course-bottom-right-expire">
                <Box className="my-course-button-expire">
                    {showComponent && courseCompletedOn ? <Box className={`completed-percentage-div `}> <GreenTick style={{height: '16px', marginTop:'10px'}}/> </Box> : <Box style={{display: 'flex', marginTop: '10px'}}><ExpiringClock/></Box>}
                    <Box style={{display: 'flex', alignItems: 'center'}}>
                        {showComponent && <span className={`ribbon-text-expire ${hasCompletedOn ? "certified-text" : ""}`} style={{maxWidth: badgeMaxWidth, marginTop: '10px'}}>{expiryLabel}</span>}
                    </Box>
                </Box>
                {settingsData?.data?.[0]?.gamification?.enabled && settingsData?.data?.[0]?.gamification?.pointsEnabled && <Box className='certificate-parent-box'>
                    <Box className='certificate-tag-align'>
                        <Box className='certificate-tag-points'><PointsIcon/></Box>
                        <Typography variant='inherit' className='card-point1'>{testData?.userAwardedPoint}/</Typography> 
                        <Typography variant='inherit' className='card-point2'>{testData?.courseTotalPoint}</Typography>
                    </Box>
                </Box>}
            </Box>
            <Box className='card-title-progress' style={{ minHeight: '26px' }}>
                <LinearProgressWithLabel value={percentageCompletion} />
            </Box>

            <Box className="card-btn-new">
                {courseExpired && !testData?.neverExpired ? (
                    <OverlayButton onClick={() => {}} title={t('VIEW_COURSE')} disabled />
                ) : (
                    <OverlayButton onClick={handleGoToTestClick} title={t('VIEW_COURSE')}/>
                )}
            </Box>
        </Box>
      </Box>
    );
}
function LinearProgressWithLabel(props) {
    return (
        <Box display="flex" alignItems="center">
            <Box mr={1} className='linearProgressDiv'>
                <LinearProgress variant="determinate" value={props.value || 0} />
            </Box>
            <Box minWidth={35}>
                <Typography variant="body2" style={{ color: '#0C3450' }}>{`${Math.round(
                    props.value || 0,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
};

MyCoursesCard.propTypes = {
    testData: PropTypes.shape({
        featured: PropTypes.string,
        endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        assignedCourseEndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        completedOnDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        progressPercent: PropTypes.number,
        neverExpired: PropTypes.bool,
        userAwardedPoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        courseTotalPoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isSelfLearning: PropTypes.bool,
        isLive: PropTypes.bool,
        courseId: PropTypes.shape({
            _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            name: PropTypes.string,
            description: PropTypes.string,
            progressPercent: PropTypes.number
        })
    }).isRequired,
    certificateListing: PropTypes.arrayOf(
        PropTypes.shape({
            courseId: PropTypes.shape({
                _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            })
        })
    ),
    settingsData: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                branding: PropTypes.shape({
                    courseImage: PropTypes.shape({
                        imagePath: PropTypes.string
                    })
                }),
                gamification: PropTypes.shape({
                    enabled: PropTypes.bool,
                    pointsEnabled: PropTypes.bool
                })
            })
        )
    })
};

MyCoursesCard.defaultProps = {
    certificateListing: [],
    settingsData: {}
};

export { MyCoursesCard, LinearProgressWithLabel };
